import React from "react";
import { Logo } from "./Logo";

export function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen bg-[#F5F6F9] flex flex-col">
      <header className="w-full px-6 sm:px-10 py-6">
        <Logo size="md" />
      </header>

      <main className="flex-1 flex items-center justify-center px-4 sm:px-8 py-6">
        <div className="w-full max-w-md">
          <div className="bg-white rounded-2xl shadow-[0_8px_28px_rgba(57,125,255,0.08)] border border-[#E5E7EB] overflow-hidden">
            <div className="h-1.5 bg-gradient-to-r from-[#397DFF] via-[#397DFF] to-[#F9C80E]" />
            <div className="px-7 sm:px-9 py-8">
              <h1 className="font-display text-3xl sm:text-4xl font-bold text-[#191D1E] tracking-tight">
                {title}
              </h1>
              {subtitle && (
                <p className="mt-2 text-[#687175] text-sm sm:text-base">{subtitle}</p>
              )}
              <div className="mt-7">{children}</div>
            </div>
          </div>
          {footer && (
            <div className="mt-5 text-center text-sm text-[#939BA0]">{footer}</div>
          )}
        </div>
      </main>

      <footer className="px-6 sm:px-10 py-5 text-xs text-[#939BA0]">
        © Place des Énergies — Phase 0 · POC
      </footer>
    </div>
  );
}

export default AuthShell;
